// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"F7-z"};